import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, IconButton, Button, Tooltip, Grid, Select, MenuItem, Input } from '@material-ui/core';
import { Cancel, ThumbUpAlt, SyncAlt } from '@material-ui/icons';
import { TRANSFER_TITLE_SITE_DOMAIN } from '../../../queries/titleContent';
import Loading from '../../../components/Loading';
import { Toast } from '../../../components/Toast';

export default function TransferTitles({ selectedTitles, refetch, sitesList }) {
  const [openLoading, setOpenLoading] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [selectedSiteDomain, setSelectedSiteDomain] = useState('');

  const [transferSiteDomain] = useMutation(TRANSFER_TITLE_SITE_DOMAIN);

  const handleClose = () => {
    setOpenConfirmation(false);
  };

  const transferTitle = async (newSiteDomain) => {
    setOpenLoading(true);
    try {
      selectedTitles.forEach(async (title) => {
        await transferSiteDomain({
          variables: {
            titleId: title.id,
            siteDomainDestination: newSiteDomain,
          },
        });
      });
    } catch (error) {
      setOpenLoading(false);
      Toast('Failed to transfer Titles!', 'error');
    } finally {
      setOpenLoading(false);
      Toast('Titles transferred successfully');
      refetch();
      handleClose();
    }
    handleClose();
    setOpenLoading(false);
  };
  const handleSitesChange = event => {
    setSelectedSiteDomain(event.target.value);
  };
  return (
    <>
      <Tooltip title="Transfer Title to new Site Domain">
        <IconButton
          color="primary"
          aria-label="pagination"
          onClick={
            e => {
              e.preventDefault();
              setOpenConfirmation(true);
            }
          }
        >
          <SyncAlt />
        </IconButton>
      </Tooltip>
      <Loading openLoading={openLoading} />
      <Dialog
        open={openConfirmation}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">Transfer  Title</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Select the new
            {' '}
            <b>SITE DOMAIN</b>
            :
            <Grid item xs={12}>
              <Select
                id="sites-lookup-id"
                value={selectedSiteDomain}
                onChange={handleSitesChange}
                input={<Input />}
                style={{ width: '100%' }}
              >
                <MenuItem key="null" value="null" selected>
                  All
                </MenuItem>
                {(sitesList
                  ? sitesList.map(item => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  )) : <></>)}
              </Select>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleClose()}
            color="default"
          >
            <Cancel />
            {'  '}
            Cancel
          </Button>
          <Button
            onClick={() => transferTitle(selectedSiteDomain)}
            color="primary"
            autoFocus
            variant="contained"
          >
            <ThumbUpAlt />
            {'  '}
            Confirm
          </Button>

        </DialogActions>
      </Dialog>
    </>
  );
}
